import moment from 'moment-mini';
import { projectAcceptedKey, projectApprovedKey, projectDeliveredKey, projectDeliveryPendingKey, projectPendingKey, } from 'root/src/shared/constants/keys';
// Seconds remaining before the dare expires. Ported from the legacy timeLeftSelector
// (`getProjectTimeLeft`): a delivered dare or a dare with no approval date has no time left.
export const getDareTimeLeft = (dare) => {
    const { approved } = dare;
    if (!approved) {
        return 0;
    }
    const delivered = dare.status === projectDeliveredKey;
    const isPending = dare.status === projectPendingKey;
    if (delivered && !isPending) {
        return 0;
    }
    if (!dare.expirationDate) {
        return 0;
    }
    return moment(dare.expirationDate).diff(moment().format(), 'seconds');
};
// Viewer-facing lifecycle badge for the dare hero. Delivered dares (or those awaiting admin
// approval after delivery) read "Completed"; expired dares read "Ended"; everything else is "Active".
export const getDareStatusBadge = (dare) => {
    const delivered = dare.status === projectDeliveredKey || dare.status === projectDeliveryPendingKey;
    if (delivered) {
        return {
            label: 'Completed',
            badge: 'border border-solid border-neon-green/40 bg-black/60 text-neon-green',
            dot: 'bg-neon-green',
        };
    }
    const timeLeft = getDareTimeLeft(dare);
    if (timeLeft <= 0) {
        return {
            label: 'Ended',
            badge: 'border border-solid border-white/20 bg-black/60 text-muted-foreground',
            dot: 'bg-muted-foreground',
        };
    }
    return {
        label: 'Active',
        badge: 'border border-solid border-neon-cyan/40 bg-black/60 text-neon-cyan',
        dot: 'bg-neon-cyan',
    };
};
// Whether the dare has a delivered video to show.
export const hasDelivery = (dare) => { var _a, _b; return Boolean((_b = (_a = dare.deliveries) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.videoURL); };
// Whether this is a sponsored (brand reward) dare vs a community pledge dare.
export const isSponsoredDare = (dare) => Boolean(dare.brandProduct);
// Per-record admin moderation visibility, ported from the legacy canApprove / canReject /
// canRejectActive selectors (the admin check is applied separately by the caller via useIsAdmin).
// Approve / Reject show for a pending dare; Reject Active shows for an approved / accepted /
// delivery-pending dare (and only when Approve is not also shown, matching AdminButtonSet).
export const canApproveDare = (dare) => dare.status === projectPendingKey;
export const canRejectDare = (dare) => dare.status === projectPendingKey;
export const canRejectActiveDare = (dare) => (dare.status === projectApprovedKey
    || dare.status === projectAcceptedKey
    || dare.status === projectDeliveryPendingKey);
